import { api } from "core/axios/axios";

/**
 * The sidebar footer and the account menu both block on this.
 *
 * `core/axios` sets no timeout, so an API that accepts the connection and then
 * never answers leaves the request pending forever — and React Query keeps
 * `isLoading` true for as long as it is. That is why the footer can sit on a
 * shimmering skeleton indefinitely instead of resolving to a name or an error.
 *
 * The timeout is set here rather than on the shared instance because a global
 * one would also apply to uploads and long-running calls, where cutting off at
 * 15s would be wrong.
 */
export async function getFooterPresignedUrl() {
    return api.get("profile", { timeout: 15_000 });
}

export async function uploadFooterDetailsRes(url: string, formData: any) {
    return api.post(url, formData);
}


export async function getFooterTemplate(url: string) {
    return api.get(url);
}


export async function updateUserProfileRes(body: any) {
    return api.put("profile", body);
}

export interface AccountDeletionDetails {
    status: "ACTIVE" | "DELETED" | "PURGING" | "PURGED";
    deleted_at?: string;
    purge_after?: string;
    grace_days?: number;
}

export async function scheduleAccountDeletion() {
    return api.delete("account-deletion");
}

export async function getAccountDeletionDetails() {
    return api.get<AccountDeletionDetails>("account-deletion");
}

export async function cancelAccountDeletion() {
    return api.put("account-deletion");
}
